import IAddArchive from 'icons/ArchiveArrowUp'
import IAddAudio from 'icons/VolumePlus'
import IAddProgram from 'icons/PlaylistPlus'
import IAddPromo from 'icons/Filmstrip'
import IAddTag from 'icons/TagPlus'
import IAddVideo from 'icons/VideoPlus'
import ICart from 'icons/Cart'
import IChevronDown from 'icons/ChevronDown'
import IChevronRight from 'icons/ChevronRight'
import IChevronUp from 'icons/ChevronUp'
import IClock from 'icons/Clock'
import IDelete from 'icons/Delete'
import IDrag from 'icons/Drag'
import IEdit from 'icons/Pencil'
import IEditPlaylist from 'icons/PlaylistEdit'
import ILock from 'icons/Lock'
import ILockOpen from 'icons/LockOpen'
import IMarkRead from 'icons/EmailOpen'
import IRevert from 'icons/Undo'
import ISave from 'icons/Floppy'
import IVideo from 'icons/Video'

// aliases
const IEditProgram = IEditPlaylist
const IAddRelease = IAddVideo

export const components = {
  IAddArchive,
  IAddAudio,
  IAddProgram,
  IAddPromo,
  IAddRelease,
  IAddTag,
  IAddVideo,
  ICart,
  IChevronDown,
  IChevronRight,
  IChevronUp,
  IClock,
  IDelete,
  IDrag,
  IEdit,
  IEditPlaylist,
  IEditProgram,
  ILock,
  ILockOpen,
  IMarkRead,
  IRevert,
  ISave,
  IVideo,
}

export default {
  'add-archive': IAddArchive,
  'add-audio': IAddAudio,
  'add-program': IAddProgram,
  'add-promo': IAddPromo,
  'add-release': IAddRelease,
  'add-tag': IAddTag,
  'add-video': IAddVideo,
  'cart': ICart,
  'chevron-down': IChevronDown,
  'chevron-right': IChevronRight,
  'chevron-up': IChevronUp,
  'clock': IClock,
  'delete': IDelete,
  'drag': IDrag,
  'edit': IEdit,
  'edit-playlist': IEditPlaylist,
  'edit-program': IEditProgram,
  'lock': ILock,
  'lock-open': ILockOpen,
  'mark-read': IMarkRead,
  'revert': IRevert,
  'save': ISave,
  'video': IVideo,
}
